import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { ICreateFuncionario, IEditFuncionario } from './funcionario.model';

@Injectable({
  providedIn: 'root'
})
export class FuncionarioService {
  private http = inject(HttpClient);

  CreateFuncionario(body: ICreateFuncionario): Observable<any> {
    return this.http.post<any>(
      `${environment.baseURL}Funcionario/CreateFuncionario`,
      body
    );
  }

  EditarFuncionario(
    pkFuncionario: number,
    body: IEditFuncionario
  ): Observable<any> {
    const url = `${environment.baseURL}Funcionario/UpdateFuncionario?id=${pkFuncionario}`;

    return this.http.put<any>(url, body);
  }

  GetFuncionarioById(pkFuncionario: number): Observable<any> {
    const url = `${environment.baseURL}Funcionario/GetFuncionarioById?id=${pkFuncionario}`;

    return this.http.get<any>(url);
  }

  GetFuncionarioByFilter(
    nomeFuncionario?: string,
    pageNumber?: number,
    pageSize?: number,
    status: number = 0
  ) {
    const invalid = ['', undefined, 0, NaN];
    const url = `${environment.baseURL}Funcionario/GetFuncionarios`;

    const params: any = {};

    if (!invalid.includes(nomeFuncionario)) {
      params.NM_FUNC = nomeFuncionario;
    }
    if (!invalid.includes(pageNumber)) {
      params.PAGE_NUMBER = pageNumber;
    }
    if (!invalid.includes(pageSize)) {
      params.PAGE_SIZE = pageSize;
    }

    params.NU_STTS_ALL = status;

    return this.http.get<any>(url, { params });
  }

  PatchFuncionario(pkFuncionario: number, status: number) {
    const url = `${environment.baseURL}Funcionario/PatchFuncionarioStatus?id=${pkFuncionario}`;

    const body = {
      NU_STTS_FUNC: status
    };

    return this.http.patch<any>(url, body);
  }

  public patchFuncionarioResetSenha(
    token: string | null,
    senha: string
  ): Observable<any> {
    const body = {
      ResetToken: token,
      TX_SENH_FUNC: senha
    };
    return this.http.patch<any>(
      `${environment.baseURL}Funcionario/PacthFuncionarioResetSenha`,
      body
    );
  }
}
